export const formContent = {
  ar: {
    eyebrow: "نموذج التواصل",
    title: "تواصل معي",
    sub: "املأ النموذج وسأعود إليك خلال 24 ساعة.",
    name: "الاسم",
    namePh: "اسمك الكامل",
    email: "البريد الإلكتروني",
    emailPh: "you@email.com",
    phone: "الهاتف",
    phonePh: "+966 5XX XXX XXX",
    optional: "(اختياري)",
    message: "الرسالة (50 حرفاً كحد أدنى)",
    messagePh: "أخبرني عن مشروعك وأهدافك والجدول الزمني...",
    submit: "إرسال الرسالة",
    sending: "جارٍ الإرسال…",
    success: "وصلتني رسالتك — سأرد عليك قريباً.",
    error: "تعذّر الإرسال — حاول مرة أخرى.",
    close: "إغلاق النموذج",
  },
  en: {
    eyebrow: "CONTACT FORM",
    title: "Get in Touch",
    sub: "Fill out the form below and I'll get back to you within 24 hours.",
    name: "Name",
    namePh: "Your full name",
    email: "Email",
    emailPh: "you@email.com",
    phone: "Phone",
    phonePh: "+966 5XX XXX XXX",
    optional: "(optional)",
    message: "Message (50 characters minimum)",
    messagePh: "Tell me about your project, goals, and timeline...",
    submit: "Send Message",
    sending: "Sending…",
    success: "Message received — I'll get back to you soon.",
    error: "Could not send — please try again.",
    close: "Close form",
  },
  fr: {
    eyebrow: "FORMULAIRE DE CONTACT",
    title: "Me contacter",
    sub: "Remplissez le formulaire ci-dessous et je vous répondrai sous 24 heures.",
    name: "Nom",
    namePh: "Votre nom complet",
    email: "E-mail",
    emailPh: "vous@email.com",
    phone: "Téléphone",
    phonePh: "+966 5XX XXX XXX",
    optional: "(optionnel)",
    message: "Message (50 caractères minimum)",
    messagePh: "Parlez-moi de votre projet, vos objectifs et votre calendrier...",
    submit: "Envoyer le message",
    sending: "Envoi…",
    success: "Message reçu — je vous réponds très vite.",
    error: "Envoi impossible — veuillez réessayer.",
    close: "Fermer le formulaire",
  },
};
